import { useFormik } from "formik";
import * as Yup from "yup";

interface UseTransferFormikProps {
    onSubmit: (values: any) => void;
}

export const transferManageValidatorSchema = Yup.object({
    status_id: Yup.string().required("Requerido"),
    reason: Yup.string().nullable(),
})
export const useTransferManageValidator = ({ onSubmit }: UseTransferFormikProps) => {
    return useFormik({
        initialValues: {
            status_id: '',
            reason: '',
        },
        validationSchema: transferManageValidatorSchema,
        onSubmit,
    })
}